import { h, Component } from "preact";
import { route } from 'preact-router';
import linkState from 'linkstate';
import style from "../../../../../style/admin";

import { getApiPath } from "../../../../../path";
import AdminMenu from "../../../../../components/admin/menu";
import AdminMenuAbout from "../../../../../components/admin/menu/about";

class AdminAboutRemoveImage extends Component {
  state = {
    literaturelist: [],
    formSubmitted: false,
    formValid: false,
    formData: {
      id_boek: ""
    }
  };

  constructor(props){
    super(props);

    this.ApiGetInfo();
  }

  ApiGetInfo = () => {
    let fetchPath = getApiPath(this.props.lang, `adminAbout/itemsWithImage`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      }
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        this.setState(previousState => ({
          ...previousState,
          literaturelist: result.data["literature"]
        }))
    }});
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState(previousState => ({
      ...previousState,
      formSubmitted: true
    }), this.validateForm());
  }

  validateForm = () => {
    if ( // required fields
      this.state.formData.id_boek == ""
    ) {
      this.setState(previousState => ({
        ...previousState,
        formValid: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        formValid: true
      }), this.doSubmit());
    }
  }

  doSubmit = () => {
    let fetchPath = getApiPath(this.props.lang, `adminAbout/removeImage`);
    fetch(fetchPath, {
      method: 'post',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
      body: JSON.stringify(this.state.formData)
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        window.location.reload();
      } else {
        alert("Something went wrong");
      }
    });
  }
  
  render() {
    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <AdminMenuAbout locale={this.props.lang} />
        <div>
          <a href={"/" + this.props.lang + "/admin/about/image/0"}>Upload afbeelding</a>

          <h2>Verwijder afbeelding</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit} enctype="multipart/form-data">
              <p>Kies hieronder een boek en klik op 'Verwijder afbeelding' om de afbeelding weg te gooien</p>

              <div class="form-group">
                <label for="id_boek">Boek</label>
                <select name="id_boek" id="id_boek" value={this.state.formData.id_boek} onInput={linkState(this, 'formData.id_boek')}>
                  <option>Kies een boek</option>
                  {this.state.literaturelist.map(listItem => {
                    return (<option value={listItem.id_boek}>{listItem.titel}</option>);
                  })}
                </select>
              </div>

              {(this.state.formSubmitted && !this.state.formValid) &&
                <div class="form-group">
                    U dient een boek te selecteren voordat de afbeelding verwijderd kan worden
                </div>
              }

              <div class="form-group">
                <button>Verwijder afbeelding</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    )
  }
}

export default AdminAboutRemoveImage;